import { createFileRoute } from '@tanstack/react-router'
import { SetPassword } from '../components/auth/SetPassword'

export const Route = createFileRoute('/set-password')({
  component: SetPassword,
})
